// Global Imports
import styled from 'styled-components';

export const AddRecipeToScheduleModalWrapper = styled.div`
	margin: 1rem;
`;